export const isValidDate = (d: any): boolean => {
    return d instanceof Date && !isNaN(d.valueOf());
};
